module.exports = __webpack_public_path__ + "img/b6.aab8fb90.jpg";